import { createContext, ReactNode, ComponentType, useState, useMemo } from 'react'
import axios from 'axios'
import { Localize, useTransformObject } from '@hilma/netina2all';

interface ChildrenProps {
    children: ReactNode
}

interface CommonQuestionsProviderValue {
    commonQuestions: CommonQuestions[] | null;
    getCommonQuestions(): Promise<void>;
    showFetchError: boolean;
}

interface CommonQuestions {
    categoryName: string;
    questions: Array<IndividualQuestions>;
}

export interface IndividualQuestions {
    id: number;
    text: string;
    answer: string;
}

export const CommonQuestionsContext = createContext<CommonQuestionsProviderValue | null>(null)

export const CommonQuestionsProvider: ComponentType<ChildrenProps> = ({ children }) => {
    const [commonQuestions, setCommonQuestions] = useState<Localize<CommonQuestions & { questions: Localize<IndividualQuestions> }>[] | null>(null);
    const transformObject = useTransformObject();

    const translatedCommonQuestions = useMemo(() => commonQuestions ? commonQuestions.map(item => {
        const object = {
            ...transformObject<CommonQuestions>(item),
            questions: item.questions.map(transformObject)
        };
        return object as CommonQuestions;
    }) : null, [transformObject, commonQuestions]);

    const [showFetchError, setShowFetchError] = useState<boolean>(false);

    const getCommonQuestions = async () => {
        if (commonQuestions) return;
        try {
            const res = await axios.get('/api/question-category/get-questions');
            setCommonQuestions(res.data);
        } catch (e) {
            setShowFetchError(true);
        }
    }

    return (
        <CommonQuestionsContext.Provider value={{ commonQuestions: translatedCommonQuestions, getCommonQuestions, showFetchError }} >
            {children}
        </CommonQuestionsContext.Provider>
    );
}